/**
 * AI チャットの返答を表示用に分割する。
 *
 * 返答はプレーンテキストとして描画し、HTML や Markdown は解釈しない。
 * リンクにするのは企画苔（kikakugoke.com）の URL だけ。参加者のコメントなどに
 * 仕込まれた外部 URL を、AI の返答経由で押させないため（情報の持ち出し・誘導対策）。
 */

export type ChatTextSegment =
  | { type: 'text'; value: string }
  | { type: 'link'; value: string; path: string };

// ドメインの直後に英数字・ドット・ハイフンが続くもの（kikakugoke.com.evil.example 等）は対象外
const SITE_URL_RE = /https:\/\/(?:www\.)?kikakugoke\.com(?![A-Za-z0-9.-])(\/[A-Za-z0-9\-._~/?#=&%]*)?/g;

/** 文末の句読点や閉じ括弧が URL に吸い込まれないよう落とす */
const TRAILING_PUNCTUATION_RE = /[.,)）。、」』]+$/;

export function splitChatText(text: string): ChatTextSegment[] {
  const segments: ChatTextSegment[] = [];
  let cursor = 0;
  for (const match of text.matchAll(SITE_URL_RE)) {
    const start = match.index ?? 0;
    let url = match[0];
    const trailing = url.match(TRAILING_PUNCTUATION_RE)?.[0] ?? '';
    if (trailing) url = url.slice(0, -trailing.length);
    const path = url.replace(/^https:\/\/(?:www\.)?kikakugoke\.com/, '') || '/';
    // "//evil.example" は React Router の Link が外部 URL として扱うのでリンクにしない
    if (path.startsWith('//')) continue;
    if (start > cursor) {
      segments.push({ type: 'text', value: text.slice(cursor, start) });
    }
    segments.push({ type: 'link', value: url, path });
    cursor = start + url.length;
  }
  if (cursor < text.length) {
    segments.push({ type: 'text', value: text.slice(cursor) });
  }
  return segments;
}
